
import * as actionTypes from '../actions/actionTypes';

const initialState = {
    selectedExercise: {
        id: null
    },
    selectedExecution: {
        id: null
    },
    selectedPattern: {
        id: null
    },
    exerciseList: {
        quantity: 8,
        offset: 0
    },
    reloadList: false,
    reloadExecutionsList: false,
    keywords_filter: [],
    exercise_name_filter: '',
    exercise_description_filter: '',
    exercise_types_filter: [],
    exercise_publishers_filter: [],
    exercise_developers_filter: [],
    release_start_filter: '',
    release_end_filter: '',
    authors_filter: null,
    exercise_style_filter: 1, // default for ExercisesStyle = Exercises
    order_by: 'exercise_name',
    new_exercise_open: false,
    exerciseDetailsOpen: false,
    search_panel_active: false,
    new_execution_open: false,
    executionDetailsOpen: false,
    exercises: [],
    execution: []
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_EXERCISE:
            return {
                ...state,
                reloadList: true
            };
        case actionTypes.EDIT_EXERCISE:
            return {
                ...state,
                reloadList: true
            };
        case actionTypes.CLOSE_EXERCISE_DETAILS:
            return {
                ...state,
                // keywords_filter: [...state.keywords_filter],
                exerciseDetailsOpen: false,
                reloadList: true
            };
        case actionTypes.ADD_EXECUTION:
            return {
                ...state,
                reloadExecutionsList: true
            };
        case actionTypes.EDIT_EXECUTION:
            return {
                ...state,
                reloadExecutionsList: true
            };
        case actionTypes.CLOSE_EXECUTION_DETAILS:
            return {
                ...state,
                // keywords_filter: [...state.keywords_filter],
                executionDetailsOpen: false,
                reloadExecutionsList: true
            };
        case actionTypes.SELECT_PATTERN:
            return {
                ...state,
                exerciseDetailsOpen: true,
                selectedPattern: { id: action.selectedPatternId }
            };
        case actionTypes.SELECT_EXERCISE:
            return {
                ...state,
                exerciseDetailsOpen: true,
                selectedExercise: { id: action.selectedExerciseId },
                reloadExecutionsList: true
            };
        case actionTypes.SELECT_EXECUTION:
            return {
                ...state,
                executionDetailsOpen: true,
                //selectedExercise: { id: action.selectedExerciseId },
                selectedExecution: { id: action.selectedExecutionId }
            };
        case actionTypes.UPDATE_EXERCISE_NAME_FILTER:
            return {
                ...state,
                search_panel_active: true,
                exercise_name_filter: action.exercise_name_filter,
                reloadList: true
            };
        case actionTypes.UPDATE_EXERCISE_DESCRIPTION_FILTER:
            return {
                ...state,
                search_panel_active: true,
                exercise_description_filter: action.exercise_description_filter,
                reloadList: true
            };
        case actionTypes.UPDATE_RELEASE_START_FILTER:
            return {
                ...state,
                search_panel_active: true,
                release_start_filter: action.release_start_filter,
                reloadList: true
            };
        case actionTypes.UPDATE_RELEASE_END_FILTER:
            return {
                ...state,
                search_panel_active: true,
                release_end_filter: action.release_end_filter,
                reloadList: true
            };
        case actionTypes.UPDATE_EXERCISES_AUTHOR_FILTER:
            return {
                ...state,
                search_panel_active: true,
                authors_filter: action.author,
                order_by: 'implemented_patterns',
                reloadList: true
            }
        case actionTypes.CLEAR_EXERCISE_FILTERS:
            return {
                ...state,
                keywords_filter: [],
                exercise_name_filter: '',
                exercise_description_filter: '',
                exercise_types_filter: [],
                exercise_publishers_filter: [],
                exercise_developers_filter: [],
                release_start_filter: '',
                release_end_filter: '',
                authors_filter: null,
                exercise_style_filter: 1,
                order_by: 'exercise_name',
                reloadList: true,
            }
        case actionTypes.UPDATE_EXERCISES_PAGINATION:
            return {
                ...state,
                exerciseList: {
                    ...state.exerciseList,
                    offset: action.offset
                }
            };
        case actionTypes.UPDATE_EXERCISES_ORDER_BY:
            return {
                ...state,
                order_by: action.order_by,
                search_panel_active: true
            };
        case actionTypes.UPDATE_EXECUTION_NAME_FILTER:
            return {
                ...state,
                search_panel_active: true,
                execution_name_filter: action.execution_name_filter,
                reloadExecutionsList: true
            };
        case actionTypes.UPDATE_EXECUTION_DESCRIPTION_FILTER:
            return {
                ...state,
                search_panel_active: true,
                execution_description_filter: action.execution_description_filter,

                reloadList: true
            };
        case actionTypes.UPDATE_EXECUTIONS_AUTHOR_FILTER:
            return {
                ...state,
                search_panel_active: true,
                authors_filter: action.author,
                order_by: 'implemented_patterns',
                reloadExecutionsList: true
            }
        case actionTypes.CLEAR_EXECUTION_FILTERS:
            return {
                ...state,
                keywords_filter: [],
                execution_name_filter: '',
                execution_description_filter: '',
                execution_types_filter: [],
                execution_publishers_filter: [],
                execution_developers_filter: [],
                authors_filter: null,
                execution_style_filter: 1,
                order_by: 'execution_name',
                reloadExecutionsList: true
            }
        case actionTypes.UPDATE_EXECUTIONS_PAGINATION:
            return {
                ...state,
                executionsList: {
                    ...state.executionsList,
                    offset: action.offset
                }
            };
        case actionTypes.UPDATE_EXECUTIONS_ORDER_BY:
            return {
                ...state,
                order_by: action.order_by,
                search_panel_active: true
            };
        case actionTypes.NEW_EXERCISE_OPEN:
            return {
                ...state,
                new_exercise_open: true,
                selectedExercise: { id: action.selectedExerciseId }
            };
        case actionTypes.NEW_EXERCISE_CLOSED:
            return {
                ...state,
                new_exercise_open: false,
                selectedExercise: { id: null }
            };
        case actionTypes.NEW_EXECUTION_OPEN:
            return {
                ...state,
                new_exercise_open: true,
                selectedExercise: { id: action.selectedExecutionId }
            };
        case actionTypes.NEW_EXECUTION_CLOSED:
            return {
                ...state,
                new_exercise_open: false,
                selectedExecution: { id: null }
            };
        case actionTypes.LIST_RELOADED:
            return {
                ...state,
                reloadList: false
            };
        case actionTypes.EXECUTIONS_LIST_RELOADED:
            return {
                ...state,
                reloadExecutionsList: false
            };
        case actionTypes.SEARCH_EXERCISES_TOGGLE:
            return {
                ...state,
                search_panel_active: !state.search_panel_active,
                keywords_filter: [],
                selectedExercise: { id: null },
            };
        case actionTypes.AUTH_LOGOUT:
            return {
                ...state,
                search_panel_active: false,
                keywords_filter: [],
                reloadList: true,
                reloadExecutionsList: true,
                exerciseList: {
                    quantity: 8,
                    offset: 0
                },
            };
        default:
            return state;
    }
};

export default reducer;